import React, { useEffect } from 'react';
import * as styles from './VersionMismatchModal.module.scss';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import Modal from '../components/Modal';
import { BaseModalContainer } from '../components/ModalContainer';

interface VersionMismatchModalProps {
  disableAnimation?: boolean;
}

const VersionMismatchModal = ({
  disableAnimation,
}: VersionMismatchModalProps) => {
  const isOpen = useAppSelector((state) => state.ui.isVersionMismatchModalOpen);
  const socket = useAppSelector((state) => state.session.socket);

  useEffect(() => {
    if (isOpen) {
      socket?.disconnect();
    }
  }, [isOpen, socket]);

  return (
    <BaseModalContainer open={isOpen} disableAnimation={disableAnimation}>
      <Modal width={420}>
        <div className={styles.container}>
          <p>
            We updated Slab while you were away!
            <br />
            Please refresh your browser to get the latest.
          </p>
          <Button
            variant="primary"
            size="large"
            onClick={() => {
              if (window.desktop?.reloadAllTabs) {
                window.desktop.reloadAllTabs();
              } else {
                document.location.reload();
              }
            }}
          >
            Get the Latest
          </Button>
        </div>
      </Modal>
    </BaseModalContainer>
  );
};

export default VersionMismatchModal;
